export const INSTALL_PATH = '/install';
export const REDIRECT_PATH = '/redirect';
export const DASHBOARD_PATH = '/dashboard';
export const ONBOARDING_PATH = '/onboarding';
export const SETTINGS_PATH = '/settings';
// Nested under /settings so the App Bridge nav menu highlights "Settings" as
// the active parent when a merchant is in one of these sub-flows (App Bridge
// determines the active item by URL nesting).
export const PLAN_PATH = '/settings/plan';
export const TOKEN_GATES_PATH = '/tokengates';
export const PRINTS_PATH = '/prints';
export const CREATORS_PATH = '/settings/creators';
export const CONTRACTS_PATH = '/settings/contracts';
export const SELF_CREATOR_DETAILS_PATH = '/settings/creators/self';
export const ROYALTY_SPLITS_PATH = '/settings/royalty-splits';

// Sent to the billing API as `redirectPath`. It is relative to the app base
// (no leading slash) — the backend builds the Shopify charge return URL as
// `${appBase}/${redirectPath}`, so this must mirror PLAN_PATH.
export const PLAN_BILLING_REDIRECT_PATH = PLAN_PATH.replace(/^\//, '');
export const DASHBOARD_BILLING_REDIRECT_PATH = DASHBOARD_PATH.replace(
  /^\//,
  ''
);
export const CUSTOMIZATIONS_EMAIL_COA_PATH = '/customizations/claimcoa';
export const CUSTOMIZATIONS_EMAIL_VIEW_NFT_PATH = '/customizations/viewnft';
export const CUSTOMIZATIONS_EMAIL_NFT_PATH = '/customizations/claimnft';
export const CUSTOMIZATIONS_CERTIFICATE_CUSTOMIZATION_PATH = '/customizations';
export const SETTINGS_EMAIL_GLOBAL_PATH = '/customizations/global';

// The product metadata editor is nested under its section (/certificate or
// /drops) so the App Bridge nav menu highlights the relevant parent item when
// editing a product — App Bridge determines the active item by URL nesting.
export const productMetadataPath = (
  id: string | number,
  defaultType?: 'nft' | 'certificate'
): string => {
  if (defaultType === 'nft') {
    return `/drops/product/${id}/nft`;
  }
  return `/certificate/product/${id}${defaultType ? `/${defaultType}` : ''}`;
};
